/**
 * @file TaskCustomerField.tsx
 * @description Поле «Клиент» формы новой задачи со страницы «Задачи»
 * (phase19.31, SC60): задача всегда о клиенте — выбор обязателен. Выбор —
 * общая боковая панель `CustomerPickerDialog` (как в «Новой сделке»).
 * Панель рисуется внутри окна формы: нажатие в ней не закрывает форму.
 */

import { UserRound } from "lucide-react";
import { useState } from "react";

import { CustomerPickerDialog } from "../../orders/CustomerPickerDialog";
import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import type { CustomerDto } from "../../../lib/api-customers";
import { customerTitle } from "../../../lib/crm-customer-view";

interface Props {
  customer: CustomerDto | null;
  onChange: (customer: CustomerDto) => void;
  error?: string | null;
}

export function TaskCustomerField({ customer, onChange, error }: Props) {
  const [picking, setPicking] = useState(false);
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor="activity-customer">Клиент</Label>
      <Button
        id="activity-customer"
        type="button"
        variant="outline"
        className="justify-start"
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? "activity-customer-error" : undefined}
        onClick={() => setPicking(true)}
      >
        <UserRound className="size-4" aria-hidden />
        <span className="truncate">{customer ? customerTitle(customer) : "Выбрать клиента"}</span>
      </Button>
      {error ? (
        <p id="activity-customer-error" className="type-caption text-[var(--status-error-fg)]">
          {error}
        </p>
      ) : null}
      {picking ? (
        <CustomerPickerDialog
          onClose={() => setPicking(false)}
          onSelect={(c) => {
            onChange(c);
            setPicking(false);
          }}
        />
      ) : null}
    </div>
  );
}
